import { useContext } from 'react';
import { Route } from '../constants';
import { buildQueryParams } from '../util';
import { isDev } from '../util/env';
import { AuthenticatedUserContext } from './AuthenticatedUserContext';

export const localDevelopmentBaseUri = 'http://localhost:5173';

const logoutRedirectQueryString = isDev ? `?redirect_uri=${encodeURIComponent(localDevelopmentBaseUri)}` : '';

export const redirectToLogout = () => {
  window.location.replace(`/api/logout${logoutRedirectQueryString}`);
};

// The authorize URL, with the same dev redirect_uri override every other authorize kickoff in
// the app applies (see RequireAuthentication). Without it, in local dev (where /api proxies to
// staging) the backend falls back to its default redirect_uri — the staging domain — so Cognito
// bounces the user to STAGING's /sign-in/callback instead of back to localhost. In prod this is a
// no-op and just returns the bare Route.Authorize path.
export const authorizeUrl = (): string => {
  const redirectUri = isDev ? `${localDevelopmentBaseUri}${Route.SignInCallback}` : undefined;
  return `${Route.Authorize}${buildQueryParams({ redirect_uri: redirectUri })}`;
};

// A thin, mockable seam around window.location.assign — jsdom's Location is locked down
// (non-configurable), so tests can't stub window.location.assign directly; they mock this instead.
export const redirectTo = (path: string) => {
  window.location.assign(path);
};

export const useAuthentication = () => {
  return useContext(AuthenticatedUserContext);
};
